<template>
  <div class="bcd-details">
    <div class="container-fluid">
      <b-row>
        <b-col>
          <h1>
            {{ $route.params.bcd_name }} <small class="text-muted">{{ $t('system.broadcast_domain') }}
            <b-badge variant="success" :title="$t('views.dnsvs.bcd_records.both_subnets')"
                     pill
                     v-if="false/*has_v4 && has_v6*/">{{ $t('system.dualstack') }}
            </b-badge>
            <b-badge v-b-modal.vpn2vlan_info variant="info"
                     pill
                     v-if="services_info && 'vpn2vlan' in services_info">VPN2VLAN
            </b-badge>
            <b-badge v-b-modal.wifi2vlan_info variant="info"
                     pill
                     v-if="services_info && 'wifi2vlan' in services_info && services_info.wifi2vlan.hmr_json.realm !== null">WiFi2VLAN
            </b-badge>
            <b-badge variant="info"
                     :to="`/macauth/bcds/${$route.params.bcd_name}`"
                     pill
                     v-if="services_info && 'wifi2vlan' in services_info && services_info.wifi2vlan.hmr_json.realm === null">KIT-IoT
            </b-badge>
          </small>
          </h1>
          <b-modal size="lg" :title="'VPN2VLAN@'+$route.params.bcd_name" ok-only id="vpn2vlan_info"
                   v-if="services_info && 'vpn2vlan' in services_info">
            <b-alert show variant="info" v-html="$t('views.dnsvs.vpn2vlan_info')"/>
            <b-table :items="[services_info.vpn2vlan.hmr_json]" :fields="vpn2vlan_fields" :stacked="true"
                     tableClass="slim_stack" responsive>
              <template v-slot:cell(dns)="data">
                <b-table :items="[data.item.dns]" :fields="vpn2vlan_dns_fields" stacked tableClass="slim_stack">
                  <template v-slot:cell(resolvers)="data">
                    <ul>
                      <li v-for="r of data.item.resolvers" v-bind:key="r"><code>{{ r }}</code>
                      </li>
                    </ul>
                  </template>
                  <template v-slot:cell(domain_search)="data">
                    <ul>
                      <li v-for="r in data.item.domain_search" v-bind:key="r">{{ r }}</li>
                    </ul>
                  </template>
                </b-table>
              </template>
              <template v-slot:cell(dhcp)="data">
                <b-table :items="[data.item.dhcp]" :fields="vpn_dhcp_config_fields" stacked tableClass="slim_stack">
                  <template v-slot:cell(range)="data">
                    <code>{{ data.item.config.pool_range[0] }}</code> -
                    <code>{{ data.item.config.pool_range[1] }}</code>
                  </template>
                  <template v-slot:cell(dhcp_servers)="data">
                    <ul>
                      <li v-for="r in data.item.servers" v-bind:key="r"><code>{{ r }}</code></li>
                    </ul>
                  </template>
                </b-table>
              </template>
              <template v-slot:cell(radius)="data">
                {{ data.item.radius.group }}
                <b-badge variant="success" v-if="data.item.radius.two_factor">2FA</b-badge>
              </template>
              <template v-slot:cell(realms)="data">
                <b-table :items="data.item.realms" :fields="vpn2vlan_realm_fields" :stacked="true"
                         tableClass="slim_stack stack_thick_row">
                  <template v-slot:cell(name)="data">
                    {{ data.item.name }}
                    <CopyField code>&lt;login_name&gt;/&lt;session_name&gt;@{{ data.item.name }}</CopyField>
                  </template>
                  <template v-slot:cell(routes)="data">
                    <i v-if="'default_route' in data.item && data.item.default_route">{{
                        $t('system.default_gateway')
                      }}</i>
                    <ul v-else>
                      <li v-for="r in [...new Set([...data.item.split_subnets_ipv4||[], ...data.item.split_subnets_ipv6||[]])]"
                          v-bind:key="r"><code>{{ r }}</code></li>
                    </ul>
                  </template>
                </b-table>
              </template>
            </b-table>
          </b-modal>
          <b-modal size="lg" title="WiFi2VLAN" ok-only id="wifi2vlan_info" v-if="services_info && 'wifi2vlan' in services_info">
            <b-alert show variant="info" v-html="$t('views.dnsvs.wifi2vlan_info')"/>
            <b-table table-class="slim_stack" :items="[services_info.wifi2vlan.hmr_json]" :fields="wifi2vlan_fields" :stacked="true">
              <template v-slot:cell(realm)="data">
                {{ data.item.realm }}
                <CopyField code>&lt;login_name&gt;@{{ data.item.realm }}.w2v.kit.edu</CopyField>
              </template>
            </b-table>
          </b-modal>
        </b-col>
        <b-col>
          <div class="float-right" style="margin-bottom: 1.5rem">
            <b-button-group>
              <b-button variant="outline-secondary" @click="$bvModal.show('evlog_bcd')">
                {{ $t('system.event_log') }}
                <netvs-icon icon="evlog"></netvs-icon>
              </b-button>
              <b-button variant="outline-primary" @click="editBCD">
                {{ $t('system.utils.update_template', { object: $tc('system.bcd', 1) }) }}
                <netvs-icon icon="edit"></netvs-icon>
              </b-button>
            </b-button-group>
          </div>
        </b-col>
      </b-row>
    </div>
    <div style="margin-bottom: 1.5rem">
    </div>
    <b-card class="shadow mb-4" no-body>
      <b-card-header v-b-toggle:overview-collapse class="collapse-header">
        <h5 class="d-inline">{{ $t('views.dnsvs.bcd_records.broadcast_domain') }}</h5>
        <netvs-icon class="collapse-icon" icon="collapse"></netvs-icon>
      </b-card-header>
      <b-card-body body-class="p-0" v-if="bcd">
        <b-collapse id="overview-collapse" visible>
          <b-table-simple responsive class="m-0" striped>
            <b-tr>
              <b-th>
                {{ $t('components.bcd_list.bcd_id') }}
              </b-th>
              <b-td>
                <BCDId :bcd_vlans="vlans" :bcd="bcd" :bcd_vni="vni" :netcmpnds_by_name="netcmpnds_by_name"
                       :netcmpnds_by_net_instnc="netcmpnds_by_net_instnc"/>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>
                {{ $t('views.dnsvs.bcd_records.broadcast_domain_name') }}
              </b-th>
              <b-td>
                {{ bcd.name }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>{{ $t('views.home.bcd_seclvl') }}</b-th>
              <b-td>
                <p>{{ bcd_seclvl_by_value[bcd.seclvl].value }} – {{
                    $t_netdb(bcd_seclvl_by_value[bcd.seclvl].description)
                  }}</p>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>{{ $t('views.home.bcd_categ') }}</b-th>
              <b-td>
                <p>{{ bcd_categ_by_name[bcd.categ].name }} – {{
                    $t_netdb(bcd_categ_by_name[bcd.categ].description)
                  }}</p>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>
                {{ $t('system.description') }}
              </b-th>
              <b-td>
                <p>{{ bcd.description }}</p>
                <b-alert variant="dark" show v-if="bcd.admin_description">
                  <b>{{ $t('system.admin_description') }}:</b> {{ bcd.admin_description }}
                </b-alert>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>
                {{ $tc('system.subnet', subnets.length) }}
              </b-th>
              <b-td>
              <span v-for="subnet in subnets" :key="subnet.cidr"><SubnetInfo
                :subnet="subnet"></SubnetInfo><br/></span>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>{{ $t('views.dnsvs.bcd_records.natvs_section') }}</b-th>
              <b-td>
                <b-link
                  target="_blank"
                  :href="$store.state.sysinfo.netdb_admin_base + `/~netadmin/natvs/user/wrapper.cgi/${bcd.name}/0/${bcd.name}/0/`"
                >{{ bcd.name }}
                </b-link>
              </b-td>
            </b-tr>
            <b-tr>
              <b-th>{{ $tc('system.gateway', 2) }}</b-th>
              <b-td>
              <span v-for="subnet in subnets" v-bind:key="subnet.default_gateway">
                <template v-if="subnet.default_gateway">
                <code class="mr-2">{{ subnet.default_gateway }}</code>
              <b-dropdown variant="light" boundary="window">
                <template v-slot:button-content>
                  <netvs-icon icon="info"></netvs-icon>
                </template>
                <b-dropdown-item :to="'/dnsvs/ips/' + subnet.default_gateway + '/records'">
                  {{ $t('views.dnsvs.bcd_records.records_to_ip') }}
                </b-dropdown-item>
              </b-dropdown>
              <br/>
                </template>
              </span>
              </b-td>
            </b-tr>
            <b-tr v-if="Object.values(do_1_n_nat).filter(n => n.value === true).length > 0">
              <b-th>{{ $tc('system.nat_src', Object.values(do_1_n_nat).filter(n => n.value === true).length) }}</b-th>
              <b-td>
              <span v-for="subnet in subnets" v-bind:key="subnet.default_gateway">
                <template v-if="do_1_n_nat[subnet.gpk].value || false">
                <template v-if="subnet.gpk in nat_src_ips">
                  <code class="mr-2" v-for="src_ip in nat_src_ips[subnet.gpk].value" v-bind:key="src_ip">{{
                      src_ip
                    }}</code>
                </template>
                <code class="mr-2" v-else-if="nat_src_ip[subnet.gpk]">{{ nat_src_ip[subnet.gpk].value }}</code>
                </template>
              </span>
              </b-td>
            </b-tr>
          </b-table-simple>
        </b-collapse>
      </b-card-body>
    </b-card>
    <BundledDBEditor v-if="bcd && bcd_edit_template" :presets="bcd_edit_presets" modal_id="edit_bcd"
                     :template="bcd_edit_template"
                     :object_title="bcd.name"
                     object_function="update" object_fq_name="nd.bcd" :old_data="bcd"
                     :non_optionals_order="['description', 'dns_search_list']"
                     :input_reducer="{ categ: bcd_categ_options, seclvl: bcd_seclvl_options }">
    </BundledDBEditor>
    <EVLogViewer v-if="bcd" modal_id="evlog_bcd" :title="'BCD \''+ bcd.name + '\''"
                 ref_obj_fq="nd.bcd" :refobj_id_value="bcd.gpk"></EVLogViewer>
  </div>
</template>

<script>

import RangeService from '@/api-services/dns_bcd.service'
import SystemInfoService from '@/api-services/system_info.service'
import apiutil from '@/util/apiutil'
import SubnetInfo from '@/components/SubnetInfo.vue'
import CopyField from '@/components/CopyField.vue'
import BCDId from '@/components/BCDId.vue'
import EVLogViewer from '@/components/EVLogViewer.vue'
import BundledDBEditor from '@/components/db-editor/BundledDBEditor.vue'
import Axios from 'axios'

export default {
  name: 'NetDocBCDDetails',
  components: { BundledDBEditor, EVLogViewer, BCDId, SubnetInfo, CopyField },
  data() {
    return {
      filter: {},
      vlans: [],
      user_possible_record_types: [],
      loaded: null,
      per_page: 50,
      current_page: {},
      full_create_record_reducer: undefined,
      full_edit_fqdn_reducer: undefined,
      db_editor_function: 'create',
      db_editor_presets: {},
      db_editor_old_data: {},
      bcd: null,
      subnets: null,
      vni: null,
      bcd_seclvl_by_value: {},
      bcd_categ_by_name: {},
      bcd_categ_options: {},
      bcd_seclvl_options: {},
      do_1_n_nat: {},
      nat_src_ip: {},
      nat_src_ips: {},
      netcmpnds_by_net_instnc: {},
      netcmpnds_by_name: {},
      services_info: null,
      resolved_vars: {},
      bcd_edit_template: null,
    }
  },
  computed: {
    bcd_edit_presets() {
      if (this.bcd == null) {
        return {}
      }
      return {
        ...this.bcd,
        bcd_name: this.bcd.name,
        bcd_gpk: this.bcd.gpk,
        dns_search_list_old: JSON.stringify(this.bcd.dns_search_list ?? [])
      }
    },
    wifi2vlan_fields() {
      // dns, dhcp, ipv4, ipv6, radius, realms
      const ret = [
        {
          key: 'realm',
        },
        {
          key: 'group_name',
          label: this.$tc('system.group', 1)
        }
      ]
      if ('wifi2vlan' in this.services_info) {
        if (this.services_info.wifi2vlan.hmr_json.comment) {
          ret.push({ key: 'comment' })
        }
      }
      return ret
    },
    vpn2vlan_fields() {
      // dns, dhcp, ipv4, ipv6, radius, realms
      const ret = [
        {
          key: 'dns',
          label: this.$t('system.dns')
        },
        {
          key: 'dhcp',
          label: this.$t('system.dhcp')
        }
      ]
      if ('vpn2vlan' in this.services_info) {
        window.console.debug('services_info', this.services_info)
        if ('ipv4' in this.services_info.vpn2vlan.hmr_json && this.services_info.vpn2vlan.hmr_json.ipv4.subnet) {
          ret.push({ key: 'ipv4' })
        }
        if ('ipv6' in this.services_info.vpn2vlan.hmr_json && this.services_info.vpn2vlan.hmr_json.ipv6.subnet) {
          ret.push({ key: 'ipv6' })
        }
        ret.push({ key: 'radius', label: this.$tc('system.group', 1) })
        ret.push({ key: 'realms' })
      }
      return ret
    },
    vpn2vlan_dns_fields() {
      const ret = [
        {
          key: 'resolvers',
          label: this.$t('views.dnsvs.resolvers')
        },
        {
          key: 'domain',
          label: this.$tc('system.domain', 1)
        },
        {
          key: 'domain_search',
          label: this.$tc('views.dnsvs.search_domain', 2)
        }
      ]
      return ret
    },
    vpn2vlan_realm_fields() {
      return [
        {
          key: 'name',
          label: this.$t('system.name')
        },
        {
          key: 'routes',
          label: this.$tc('system.ip_route', 2)

        }
      ]
    },
    vpn_dhcp_config_fields() {
      const ret = []
      if (this.services_info.vpn2vlan.hmr_json.dhcp.config) {
        ret.push({
          key: 'range',
          label: 'range'
        })
      }
      if (this.services_info.vpn2vlan.hmr_json.dhcp.servers) {
        ret.push({
          key: 'dhcp_servers',
          label: 'dhcp servers'
        })
      }
      return ret
    }
  },
  props: {
    bcd_name: {
      type: String,
      required: true
    }
  },
  async created() {
    this.bcd_edit_template = (await Axios.get('/bundled_json_templates/bcd_edit_dirty_policies.json')).data
    await this.fetchData()
  },
  methods: {
    async deepTransformStrings(value, transform) {
      if (typeof value === 'string') {
        return await transform(value)
      }
      if (Array.isArray(value)) {
        return await Promise.all(value.map(async (item) => await this.deepTransformStrings(item, transform)))
      }
      if (value !== null && typeof value === 'object') {
        const result = {}
        for (const [key, val] of Object.entries(value)) {
          result[key] = await this.deepTransformStrings(val, transform)
        }
        return result
      }
      return value
    },
    async fetchData() {
      this.loaded = null
      const rangeResponse = await RangeService.getDetail(this.$store.state, this.bcd_name)
      if (rangeResponse.data.bcd_list.length === 0) {
        await this.$router.replace('/404')
        return
      }
      this.bcd = rangeResponse.data.bcd_list[0]
      this.bcd_seclvl_by_value = apiutil.dict_by_value_of_array(rangeResponse.data.bcd_seclvl_list, 'value')
      this.bcd_categ_by_name = apiutil.dict_by_value_of_array(rangeResponse.data.bcd_categ_list, 'name')
      const categ_list = rangeResponse.data.bcd_categ_full
      const seclvl_list = rangeResponse.data.bcd_seclvl_full
      this.bcd_categ_options = {}
      categ_list.forEach(c => {
        let display_name = c.name
        if (c.description) {
          display_name += ' – ' + this.$t_netdb(c.description)
        }
        this.bcd_categ_options[c.name] = { display_name: display_name }
      })
      this.bcd_seclvl_options = {}
      seclvl_list.forEach(s => {
        let display_name = String(s.value)
        if (s.description) {
          display_name += ' – ' + this.$t_netdb(s.description)
        }
        this.bcd_seclvl_options[String(s.value)] = { display_name: display_name }
      })
      this.vni = rangeResponse.data.vxlan_list[0]
      this.subnets = rangeResponse.data.ip_subnet_list
      this.do_1_n_nat = apiutil.dict_by_value_of_array(rangeResponse.data.nat_info.filter(e => e.ot_attr_def_key_word === 'do_1_n_nat'), 'object_gfk')
      this.services_info = await this.deepTransformStrings(rangeResponse.data.services_info[0].value, this.resolveSysVars)
      // TODO: the singular-version can be removed once the migration is finished.
      this.nat_src_ip = apiutil.dict_by_value_of_array(rangeResponse.data.nat_info.filter(e => e.ot_attr_def_key_word === '1_n_nat_src_ip'), 'object_gfk')
      this.nat_src_ips = apiutil.dict_by_value_of_array(rangeResponse.data.nat_info.filter(e => e.ot_attr_def_key_word === '1_n_nat_src_ips'), 'object_gfk')
      this.vlans = rangeResponse.data.vlan_list
      this.loaded = true
      this.$store.commit('setNavigationRefreshHandle', { gpk: this.bcd.gpk, objType: 'nd.bcd' })
      this.netcmpnds_by_net_instnc = apiutil.dict_of_lists_by_value_of_array(rangeResponse.data.net_cmpnd2instnc_list, 'net_instnc')
      this.netcmpnds_by_name = apiutil.dict_by_value_of_array(rangeResponse.data.net_cmpnd_list, 'name')
    },
    editBCD() {
      this.$root.$emit('bv::show::modal', 'edit_bcd')
    },
    async resolveSysVars(str) {
      const expansion_regex = /{{\s(.*)\s}}/gmi
      let m
      while ((m = expansion_regex.exec(str)) !== null) {
        if (m.index === expansion_regex.lastIndex) {
          expansion_regex.lastIndex++
        }
        const token = m[1].toLowerCase()
        const add_toks = token.split('+').map(e => e.trim())
        const acc_arr = []
        for (let i = 0; i < add_toks.length; i++) {
          if (add_toks[i].startsWith('[') && add_toks[i].endsWith(']')) {
            acc_arr.push(...JSON.parse(add_toks[i].replaceAll('"', '\\"').replaceAll("'", '"')))
          } else {
            if (!(add_toks[i] in this.resolved_vars)) {
              this.resolved_vars[add_toks[i]] = (await SystemInfoService.getSysVar(add_toks[i])).data.value
            }
            if (add_toks.length === 1) {
              return this.resolved_vars[token]
            }
            acc_arr.push(...(this.resolved_vars[add_toks[i]] ? this.resolved_vars[add_toks[i]] : [`${add_toks[i]}[unresolved sysvar]`]))
          }
        }
        return acc_arr
      }
      return str
    },
  },
}
</script>

<style>
.bcd-details .collapse-icon {
  display: inline;
  vertical-align: center;
  float: right;

  transition: transform;
  transition-duration: 250ms;
}

.bcd-details .not-collapsed > .collapse-icon {
  transform: rotate(-180deg);
}

.collapse-header {
  z-index: 69;
}

.slim_stack > tbody > tr > td::before {
  width: 20% !important;
  text-align: center;
}

.slim_stack > tbody > tr > td > div {
  width: calc(100% - 20%) !important;
}

.slim_stack > tbody > tr > :first-child {
  border-top-width: 1px !important;
}

.stack_thick_row > tbody > tr > :first-child {
  border-top-width: 4px !important;
}
</style>
